import { ChevronDown, Wand2, X } from "lucide-react";
import { useState } from "react";

import { STATUS_LABELS, frDate, visibleTags } from "@/components/pipeline/utils";

const isSep = (n) => !n || /^-+$/.test(n);
const HEADER_FIELDS = ["Téléphone", "E-mail"];

const Tags = ({ lead, meta, saving, save }) => {
  const [v, setV] = useState("");
  const add = () => { const t = v.trim(); if (t && !lead.tags.includes(t)) save({ tags: [...lead.tags, t] }); setV(""); };
  return (
    <div className="ldx-tags" data-testid="lead-tags">
      {visibleTags(lead.tags).map((t) => <button key={t} type="button" className="chip" disabled={saving} onClick={() => save({ tags: lead.tags.filter((x) => x !== t) })} data-testid={`lead-tag-${t}`}>{t} <X size={11} /></button>)}
      <input list="ldx-tag-options" value={v} placeholder="+ tag" onChange={(e) => setV(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} data-testid="lead-tag-input" />
      <datalist id="ldx-tag-options">{visibleTags(meta.tags).map((t) => <option key={t} value={t} />)}</datalist>
    </div>
  );
};

const Field = ({ n, draft, setDraft, hint, label }) => (
  <label className={`ldx-f${draft[n] ? "" : " is-empty"}`}>
    <span>{label || n}</span>
    <input value={draft[n] ?? ""} onChange={(e) => setDraft({ ...draft, [n]: e.target.value })} placeholder={hint || "—"} data-testid={`lead-field-${n.replace(/\W+/g, "-")}`} />
  </label>
);

// Champs utiles au type de prospect d'abord, les autres repliés ; script de qualification recopié en un clic
export const FieldsCard = ({ lead, data, meta, saving, save }) => {
  const fields = data.fields || {};
  const names = [...new Set([...Object.keys(fields), ...meta.fields])].filter((n) => !isSep(n));
  const main = (data.profile?.fields || []).filter((n) => names.includes(n));
  const rest = names.filter((n) => !main.includes(n) && !HEADER_FIELDS.includes(n));
  const [draft, setDraft] = useState(() => Object.fromEntries(names.map((n) => [n, fields[n] ?? ""])));
  const changed = names.filter((n) => (draft[n] ?? "") !== (fields[n] ?? ""));
  const script = data.script_fields || {};
  const nScript = Object.keys(script).length;
  const labels = data.profile?.labels || {};
  return (
    <section className="card ldx-fields" data-testid="lead-fields">
      <header className="ldx-card-head">
        <h2 className="card__title">Fiche <small data-testid="lead-profile">{data.profile?.label}</small></h2>
        {changed.length > 0 && <button type="button" className="btn btn--sm btn--ink" disabled={saving} onClick={() => save({}, Object.fromEntries(changed.map((n) => [n, draft[n]])))} data-testid="lead-fields-save">{saving ? "Enregistrement…" : `Enregistrer ${changed.length}`}</button>}
      </header>
      {nScript > 0 && (
        <div className="ldx-script" data-testid="lead-script-fill">
          <p><Wand2 size={14} /> Script de qualification : {nScript} champ{nScript > 1 ? "s" : ""} à recopier</p>
          <ul>{Object.entries(script).map(([k, v]) => <li key={k}><span>{labels[k] || k}</span><b>{v}</b></li>)}</ul>
          <button type="button" className="btn btn--sm btn--ink" disabled={saving} onClick={() => save({}, script)} data-testid="lead-script-fill-btn">Remplir les champs</button>
        </div>
      )}
      <div className="ldx-grid">
        <label className="ldx-f"><span>Statut</span>
          <select value={lead.status} disabled={saving} onChange={(e) => save({ status: e.target.value })} data-testid="opportunity-field-status">{Object.entries(STATUS_LABELS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        </label>
        <label className="ldx-f"><span>Montant (€)</span>
          <input type="number" key={`a${lead.id}${lead.amount}`} defaultValue={lead.amount ?? ""} onBlur={(e) => e.target.value !== String(lead.amount ?? "") && save({ amount: Number(e.target.value) || 0 })} placeholder="—" data-testid="opportunity-field-amount" />
        </label>
        {main.map((n) => <Field key={n} n={n} label={labels[n]} draft={draft} setDraft={setDraft} hint={script[n]} />)}
      </div>
      <Tags lead={lead} meta={meta} saving={saving} save={save} />
      {rest.length > 0 && (
        <details className="ldx-more" data-testid="lead-more-fields">
          <summary><ChevronDown size={14} /> Autres champs ({rest.length})</summary>
          <div className="ldx-grid">{rest.map((n) => <Field key={n} n={n} draft={draft} setDraft={setDraft} />)}</div>
        </details>
      )}
      <p className="ldx-dates">Créée le {frDate(lead.created_at)} · mise à jour le {frDate(lead.updated_at)}</p>
    </section>
  );
};
